import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { MessageDescriptorPropType } from '../../../prop-types/intl';

import { noop } from 'ui-components/default-props/noop';
import { emptyObject } from 'ui-components/default-props/empty';

const OtherShippingOptionsFormOption = ({
  option = emptyObject,
  fulfillmentPlanId,
  onOptionUpdated = noop,
  onInputUpdated = noop,
  isChecked = false,
  value,
  handleCheck = noop,
  sellerLabelProviderId = null,
}) => {
  const onCheck = useCallback(
    (props) => {
      handleCheck(option.optionName, props);
    },
    [handleCheck, option.optionName],
  );

  const Option = option.component;

  return (
    <Option
      checked={isChecked}
      fulfillmentPlanId={fulfillmentPlanId}
      id={option.optionName}
      label={<FormattedMessage {...option.fullName} />}
      onCheck={onCheck}
      optionData={value}
      sellerLabelProviderId={sellerLabelProviderId}
      tooltip={option.tooltip}
      updateInput={onInputUpdated}
      updateOption={onOptionUpdated}
    />
  );
};

export default OtherShippingOptionsFormOption;

OtherShippingOptionsFormOption.propTypes = {
  option: PropTypes.shape({
    optionName: PropTypes.string,
    component: PropTypes.elementType,
    fullName: MessageDescriptorPropType,
    tooltip: MessageDescriptorPropType,
  }),
  fulfillmentPlanId: PropTypes.string,
  onOptionUpdated: PropTypes.func,
  onInputUpdated: PropTypes.func,
  isChecked: PropTypes.bool,
  value: PropTypes.any,
  handleCheck: PropTypes.func,
  sellerLabelProviderId: PropTypes.string,
};
